module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    staticStyle: {
      "padding-left": "50px"
    }
  }, [_c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "the-north-sea"
    }
  }, [_c('div', {
    staticClass: "section level4",
    attrs: {
      "id": "part-2-lowlands"
    }
  }, [_c('div', {
    staticClass: "section level5",
    attrs: {
      "id": "groningen-the-netherlands-19301949"
    }
  }, [_c('p', {
    staticStyle: {
      "width": "550px",
      "padding-top": "20px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("were not many people on the tram so I asked the conductor to let me know when we had reached my destination. As we left the station I looked around, I saw nothing. As the tram clattered on, I still saw nothing – there were just the rails, the road, the outline of a kerb and footpath, and mist. When the conductor told me that we had arrived at my destination I stepped out into nothingness. Only when I stood on the footpath could I see that next to it were the vague outlines of low remnants of walls, standing in great stretches of grey and brick-red rubble. I realised that this had been Rotterdam.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("The destruction in Groningen was massive, but the scale of this calamity was overwhelming. I stood in a mist-shrouded field of rubble, trying to grasp what I saw and then multiplying it to account for the destruction in all those other cities in Europe and in other parts of the world. What right did I have to think of spending my life painting? Who could live in a work of art? I was beginning to think that there were other things to do.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("After Rotterdam, I was allowed to go on more travel. Jan, Henk, and I spent a summer holiday in the east of the country, in a deserted chicken shed. We slept on straw, lived on bread and spam, and discovered that you could cause a mini explosion by putting a match to a fart. Our experiments singed the hair on our bums and almost burned down the straw-filled shed. I had previously painted a portrait of Jan, so this time I painted Henk, sitting on the floor of the shed. I also painted the farmhouse of the farmer who owned the shed – a reed-covered Saxon barn, standing amongst poplars that slightly bent in a breeze that whispered through their silver-green leaves.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("The next year, Henk and I managed to wheedle approval out of our parents for getting a passport. The scheme was that we would hitchhike to Breda, on the Dutch side of the border of Belgium. There, my uncle who had been in Java was now a minister. As part of his congregation was in Belgium and because he had a car, we might be able to travel with him and learn about a foreign country. We did indeed get to Breda and slept at my uncle’s but the next morning we were over the border; Henk and I were determined to see Paris. We hitchhiked that day to the southwest of Belgium, where we slept in the hay at a farm. Although the farmer spoke Flemish, we found that we could not understand a word of what he said, and we had to make do with gestures and a bit of French.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("The following morning we were below Lille, in the north of France, walking south along the road, when a tall tanker stopped and Henk and I were hoisted into the cabin by the French driver. Yes, he was going to Paris, to deliver a tank of beer from Lille. We set in the high cabin and saw northern France roll by – I thought that moving up and down the ridged landscape was like taking a ship across waves. The driver had an amazing ability; he could see from far away whether or not a woman walking or cycling in any of the villages we passed through was what he considered to be attractive. Henk and I passed the time trying to match his skill but we got nowhere. We thought that perhaps our eyes were not as good as his but he insisted it was just our lack of experience.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b01b7d5a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0042.vue
// module id = 186
// module chunks = 0